import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
    GetPaymentMethodsAction,
    RemovePaymentMethodAction,
    UpdateDefaultCard,
} from "../../redux/actions/paymentmethods";
import Header from "../Header";
import Footer from "../Footer";
import moment from "moment";

const ViewCard = ({
    auth,
    getCards,
    paymentmethods,
    removeCard,
    makeDefault,
}) => {
    useEffect(() => {
        getCards().then();
    }, []);
    return (
        <>
            <Header />
            <section className="jobs">
                <input
                    type="hidden"
                    id="cardUserId"
                    className="paymentCardID"
                />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <fieldset className="border p-3 mb-3 ">
                                <legend className="w-auto blue">
                                    Card Details
                                </legend>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Card Brand</th>
                                            <th scope="col">Card Number</th>
                                            <th scope="col">Expiry</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody id="view-paymentCard-details">
                                        {paymentmethods.map((pm) => (
                                            <tr key={pm.id}>
                                                <td>{pm.card_brand}</td>
                                                <td>
                                                    **** **** ****{" "}
                                                    {pm.card_end_number}
                                                </td>
                                                <td>
                                                    {pm.exp_year && pm.exp_month
                                                        ? pm?.exp_month?.toString()?.padStart(
                                                              2,
                                                              "0"
                                                          ) +
                                                          "/" +
                                                          pm.exp_year
                                                        : "N/A"}
                                                </td>
                                                <td>
                                                    {pm.is_default == 1
                                                        ? "Default"
                                                        : ""}
                                                </td>
                                                <td>
                                                    {pm.is_default == 0 ? (
                                                        <button
                                                            onClick={() =>
                                                                makeDefault(
                                                                    pm.id
                                                                )
                                                            }
                                                            type="button"
                                                            className="btn btn-sm btn-danger mr-2"
                                                        >
                                                            Make Default
                                                        </button>
                                                    ) : null}

                                                    <button
                                                        onClick={() =>
                                                            removeCard(pm.id)
                                                        }
                                                        type="button"
                                                        className="btn btn-sm btn-danger"
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    paymentmethods: state.paymentmethods,
});

const mapDispatchToProps = (dispatch) => ({
    getCards: async () => dispatch(await GetPaymentMethodsAction()),
    removeCard: async (id) => dispatch(await RemovePaymentMethodAction(id)),
    makeDefault: async (id) => dispatch(await UpdateDefaultCard(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCard);
